import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-arrowelbowright",
  "use": "icon-th-arrowelbowright-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-arrowelbowright\">\n<path d=\"M30 10V19C30 19.2652 29.8947 19.5196 29.7071 19.7071C29.5196 19.8946 29.2652 20 29 20C28.7348 20 28.4804 19.8946 28.2929 19.7071C28.1054 19.5196 28 19.2652 28 19V12.4137L15.7075 24.7075C15.6146 24.8005 15.5043 24.8742 15.3829 24.9246C15.2615 24.9749 15.1314 25.0008 15 25.0008C14.8686 25.0008 14.7385 24.9749 14.6171 24.9246C14.4957 24.8742 14.3854 24.8005 14.2925 24.7075L2.29251 12.7075C2.10487 12.5199 1.99945 12.2654 1.99945 12C1.99945 11.7346 2.10487 11.4801 2.29251 11.2925C2.48015 11.1049 2.73464 10.9994 3.00001 10.9994C3.26537 10.9994 3.51987 11.1049 3.70751 11.2925L15 22.5863L26.5863 11H20C19.7348 11 19.4804 10.8946 19.2929 10.7071C19.1054 10.5196 19 10.2652 19 10C19 9.73478 19.1054 9.48043 19.2929 9.29289C19.4804 9.10536 19.7348 9 20 9H29C29.2652 9 29.5196 9.10536 29.7071 9.29289C29.8947 9.48043 30 9.73478 30 10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-arrowelbowright.svg
// module id = oKqT
// module chunks = 84